var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.diffTree)?_c('Diff',{staticClass:"DiffLaptops",attrs:{"diffTree":_vm.diffTree,"doCompactMatched":_vm.doCompactMatched,"keys":_vm.$ta('diffKeys')},on:{"accept":_vm.accept,"reject":_vm.reject}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }